import ContactCard from '@components/contact-card/ContactCard';
import UserContext from '@context/UserContext';
import useRouter from '@hooks/useRouter';
import { ChevronRight } from '@mui/icons-material';
import { Box, Grid, Paper, Typography } from '@mui/material';
import routes from '@routes';
import useCommonStyles from '@styles/common.style';
import React, { useContext, useMemo } from 'react';

import { contactDataByMarket } from './contactData';

const Resources = () => {
  const { classes: common } = useCommonStyles();
  const router = useRouter();
  const userContext = useContext<UserContext>(UserContext);

  // Determine user's market based on activeRegion
  const userMarket = useMemo(() => {
    const regionName = userContext.activeRegion?.docID || '';

    console.log('userContext', userContext);
    console.log(regionName);
    
    if (regionName.includes('denver_boulder') || regionName.includes('denver') || regionName.includes('boulder')) {
      return 'colorado';
    }
    if (regionName.includes('california') || regionName.includes('san diego') || regionName.includes('orange county')) {
      return 'california';
    }
    
    // Default to California if region is unclear
    return 'california';
  }, [userContext.activeRegion]);

  // Get contacts for the user's market
  const contactData = useMemo(() => {
    return contactDataByMarket[userMarket] || contactDataByMarket.california;
  }, [userMarket]);

  return (
    <Box
      className={common.contentSpacing}
    >
      <Typography
        component="h1"
        variant="h3Alt"
        style={{ marginBottom: 24 }}
      >
        Resources
      </Typography>

      {/* Contact Cards */}
      <Grid
        container
        spacing={2}
        style={{ marginBottom: 16 }}
      >
        {contactData.map((contact) => (
          <Grid
            key={contact.email}
            item
            xs={12}
            md={6}
          >
            <ContactCard {...contact} />
          </Grid>
        ))}
      </Grid>

      {/* Resource Center Card */}
      <Paper
        role="button"
        tabIndex={0}
        style={{
          padding: 16,
          borderRadius: 10,
          backgroundColor: '#ffffff',
          border: '1px solid #EBEBEB',
          marginBottom: 16,
          cursor: 'pointer',
        }}
        onClick={() => router.push(routes.resourcesNotion.path)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            router.push(routes.resourcesNotion.path);
          }
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <Typography
              variant="h5Alt"
              style={{ marginBottom: 4, fontWeight: 600 }}
            >
              Resource Center
            </Typography>
            <Typography
              variant="body2"
              style={{ color: '#666666' }}
            >
              Education resources and easy to download materials
            </Typography>
          </Box>
          <ChevronRight
            style={{ color: '#666666' }}
          />
        </Box>
      </Paper>

      {/* Case Studies Card */}
      <Paper
        role="button"
        tabIndex={0}
        style={{
          padding: 16,
          borderRadius: 10,
          backgroundColor: '#ffffff',
          border: '1px solid #EBEBEB',
          marginBottom: 16,
          cursor: 'pointer',
        }}
        onClick={() => {
          window.open('https://guesthouseshop.com/shop/homes', '_blank');
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.open('https://guesthouseshop.com/shop/homes', '_blank');
          }
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <Typography
              variant="h5Alt"
              style={{ marginBottom: 4, fontWeight: 600 }}
            >
              Case Studies
            </Typography>
            <Typography
              variant="body2"
              style={{ color: '#666666' }}
            >
              Real examples of how we help homes sell faster and for more
            </Typography>
          </Box>
          <ChevronRight
            style={{ color: '#666666' }}
          />
        </Box>
      </Paper>

      {/* FAQs Card */}
      <Paper
        role="button"
        tabIndex={0}
        style={{
          padding: 16,
          borderRadius: 10,
          backgroundColor: '#ffffff',
          border: '1px solid #EBEBEB',
          marginBottom: 16,
          cursor: 'pointer',
        }}
        onClick={() => {
          window.open('https://guesthouseshop.com/support#booking%20a%20staging', '_blank');
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.open('https://guesthouseshop.com/support#booking%20a%20staging', '_blank');
          }
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <Typography
              variant="h5Alt"
              style={{ marginBottom: 4, fontWeight: 600 }}
            >
              FAQs
            </Typography>
            <Typography
              variant="body2"
              style={{ color: '#666666' }}
            >
              Answers to common questions
            </Typography>
          </Box>
          <ChevronRight
            style={{ color: '#666666' }}
          />
        </Box>
      </Paper>

      {/* Prep Now, Pay Later Card */}
      <Paper
        role="button"
        tabIndex={0}
        style={{
          padding: 16,
          borderRadius: 10,
          backgroundColor: '#ffffff',
          border: '1px solid #EBEBEB',
          marginBottom: 16,
          cursor: 'pointer',
        }}
        onClick={() => {
          window.open('https://notablefi.com/guesthouse/apply', '_blank');
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.open('https://notablefi.com/guesthouse/apply', '_blank');
          }
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <Typography
              variant="h5Alt"
              style={{ marginBottom: 4, fontWeight: 600 }}
            >
              Prep Now, Pay Later
            </Typography>
            <Typography
              variant="body2"
              style={{ color: '#666666' }}
            >
              Learn about our pay-at-close option in partnership with Notable
            </Typography>
          </Box>
          <ChevronRight
            style={{ color: '#666666' }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default React.memo(Resources);
